import api, { openApi } from "./api";

export const getLandingImageUrl = (filename) => {
  if (!filename) return null;
  const baseURL = api.defaults.baseURL || "";
  const origin = baseURL.includes("/api/") ? baseURL.split("/api/")[0] : baseURL;
  return origin + "/public/landing/" + filename;
};

export const getPublicLandingSections = async () => {
  const { data } = await openApi.get("/open/landing-sections");
  return data || {};
};

export const saveLandingSection = async (sectionKey, content) => {
  const { data } = await api.put("/landing-sections/" + sectionKey, { content });
  return data;
};

export const uploadLandingImage = async (file) => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post("/landing-sections/upload-image", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.filename;
};
